<template>
  <v-card class="codeblock pl-4 pt-4 pb-2 mb-2">
    <p class="code">
      {{ this.content }}
    </p>
  </v-card>
</template>

<script>
export default {
  name: "VCode",
  props: {
    content: String
  }
};
</script>

<style scoped>
.codeblock {
  background-color: #222828;
}
.code {
  background-color: #222828;
  color: white;
  font-family: monospace;
  white-space: pre;
}
</style>
